import { SVGProps } from 'react'

export const Cross = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.99999 3.93933L12.25 11.1893L19.5 3.93933L20.5607 4.99999L13.3107 12.25L20.5607 19.5L19.5 20.5607L12.25 13.3107L4.99999 20.5607L3.93933 19.5L11.1893 12.25L3.93933 4.99999L4.99999 3.93933Z"
      fill="currentColor"
    />
  </svg>
)
